export enum OtherOccurrenceEntryPoint {
  Tags = 'tags',
  Modal = 'modal',
}
